export default __webpack_public_path__ + "static/media/cancel.0319344e.svg";